export default __webpack_public_path__ + "static/media/indexHistory.877b5440.png";